"use strict";
import { DefineModel, Action, Effects, Tuple } from "../util/pine";
import { Link } from "react-router";
import { FlashMessages } from "../components/flash_messages";
import Api from "../api/api";
import Auth from "../util/auth";
import ModuleDropdown from "../components/module_dropdown";
import AlertArea from "../components/alert_area";
import LoadQuickSearch from "./load_quick_search";
import ListFilterHelper from "./list_filter_helper";
import ElmApp from "./elm-app";
import TrainingEnvironmentNavigation from "./training_environment/navigation";
import TrainingEnvironmentToC from "./training_environment/table_of_contents";
import TrainingEnvironmentVideo from "./training_environment/video";
import { History } from "react-router";
import BeamerUpdates from "./beamer_updates";
import StaffBar from "../shared/staff_bar";
import Account from "../api/account";
const Model = DefineModel("AccountsPayableApp", {
  elm: null,
  hideNavbar: false
});
const init = (get, route) => {
  return routeUpdate(get, Model.create(), route);
};
const RouteUpdate = Action(Model, "RouteUpdate");
const CacheUpdate = Action(Model, "CacheUpdate");
const PushUpdate = Action(Model, "PushUpdate");
const update = (get, model, [action, payload]) => {
  switch (action) {
    case RouteUpdate:
      return routeUpdate(get, model, payload);
    case CacheUpdate:
      return Tuple(model, Effects.none);
    case PushUpdate:
      return Tuple(model, Effects.none);
    default:
      return Tuple(model, Effects.none);
  }
};
const routeUpdate = (get, model, route) => {
  const matchElm = route.pathname.match(/\/elm/) || route.pathname.match(/\/help/) || route.pathname.match(/\/okta_login/) || route.pathname.match(/\/billing_requirements/) || route.pathname.match(/\/documents_viewer/) || route.pathname.match(/\/email_search/) || route.pathname.match(/\/settings\/account/) || route.pathname.match(/\/settings\/document_types/) || route.pathname.match(/\/settings\/carriers\/\d+\/documents/) || route.pathname.match(/\/settings\/contacts/) || route.pathname.match(/\/settings\/customers/) || route.pathname.match(/\/settings\/integrations/) || route.pathname.match(/\/settings\/next_gen_audit/) || route.pathname.match(/\/settings\/client_portal/) || route.pathname.match(/\/settings\/debtors/) || route.pathname.match(/\/settings\/verifications/) || route.pathname.match(/\/settings\/exceptions/) || route.pathname.match(/\/settings\/carriers/) || route.pathname.match(/\/settings\/reference_fields/) || route.pathname.match(/\/settings\/reports/) || route.pathname.match(/\/settings\/rules/) || route.pathname.match(/\/settings\/users/) || route.pathname.match(/\/settings\/scraper_status/) || route.pathname.match(/\/terms/) || route.pathname.match(/\/client_submission\//) || route.pathname.match(/\/verification_batch\//) || route.pathname.match(/\/index-document-batches\/[0-9]+\/loads\/[0-9]+\/confirm/) || route.pathname.match(/\/forwarding\//) || route.pathname.match(/\/dashboard\/?([^\/]*)/) || route.pathname.match(/\/activity/) || route.pathname.match(/\/loads\/[0-9]+\/carrier_invoices\/[0-9]+\/ltl-reconcile/) || route.pathname.match(/\/forwarding-has-moved/) || route.pathname.match(/\/held_submissions/) || (route.pathname === "/" ? [] : false);
  const hideNavbar = route.pathname.match(/\/billing_requirements/) || route.pathname.match(/\/documents_viewer/) || route.pathname.match(/\/okta_login/);
  if (matchElm) {
    const newModel2 = model.set("elm", true).set("hideNavbar", hideNavbar);
    return Tuple(newModel2, Effects.none);
  }
  const newModel = model.set("elm", false).set("hideNavbar", hideNavbar);
  return Tuple(newModel, Effects.none);
};
const isSandbox = () => {
  return Auth._currentUser && Auth._currentUser.account && !Auth._currentUser.account.demo && Auth._currentUser.account.sandbox || false;
};
const onScraperPage = (location) => {
  return location && location.pathname === "/to_be_scraped_loads";
};
const App = React.createClass({
  mixins: [History],
  propTypes: {
    location: React.PropTypes.object,
    children: React.PropTypes.node,
    model: React.PropTypes.object,
    mailbox: React.PropTypes.object
  },
  statics: {
    RouteUpdate,
    CacheUpdate,
    PushUpdate,
    init,
    update
  },
  getInitialState: function() {
    let loggedIn = Auth.isAuthenticated();
    return {
      loggedIn,
      showTrainingVideo: false,
      showTrainingLessonToC: false,
      training: {
        loading: true,
        lessons: [],
        userToken: "",
        currentLesson: {
          title: "",
          description: ""
        }
      },
      v3ReskinTopLevelChecked: true
    };
  },
  updateAuth: function(loggedIn) {
    this.setState({
      loggedIn,
      showTrainingVideo: false,
      showTrainingLessonToC: false
    });
    if (loggedIn && this.isTrainingAccount()) {
      Api.TrainingEnvironment.trainingUserData(this.account().id).then((result) => {
        this.setState({
          training: {
            loading: false,
            videoUrl: result.cur_lesson.video,
            userToken: result.trainingUserToken,
            lessons: result.lessons,
            currentLesson: result.cur_lesson
          },
          showTrainingVideo: result.cur_lesson.watched_video != true
        });
      });
    }
    if (this.refs.elmApp) {
      this.refs.elmApp.updateHeaderFlags(this.headerFlagsForElm());
    }
  },
  componentWillMount: function() {
    Auth.onChange = this.updateAuth;
    Auth.currentUser().catch((error) => {
      if (error.response.status !== 401) throw error;
    });
    if (this.isIndexAuditSplitAccount()) {
      if (this.props.location.pathname.includes("/dashboard") && this.props.location.query["dashboardMode"]) {
        let dashboardDestination;
        if (this.props.location.query["dashboardMode"] === "audit" && this.isPayablesAccount()) {
          dashboardDestination = "/dashboard/ready-to-audit";
        } else if (this.props.location.query["dashboardMode"] === "index" && !this.isPayablesAccount()) {
          dashboardDestination = "/dashboard/indexing";
        } else {
          dashboardDestination = "/dashboard/new";
        }
        localStorage.setItem("dashboardDestination", dashboardDestination);
      }
    }
  },
  logoutLink: function() {
    if (Auth.isAuthenticated()) {
      return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Link, { to: "/logout" }, "Log out"));
    }
  },
  groupUsers: function() {
    if (Auth.isAuthenticated()) {
      let user = Auth.getCurrentUser();
      if (user.group_user_info && user.group_user_info.length > 0) {
        return /* @__PURE__ */ React.createElement("li", { className: "group-users-li" }, /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "group-users-select",
            onChange: this.switchUserFromSelect,
            defaultValue: user.id
          },
          this.groupUserOptions(user.group_user_info, user.id)
        ));
      }
    }
  },
  groupUserOptions: function(group_user_info, current_user_id) {
    return group_user_info.map((row) => {
      return /* @__PURE__ */ React.createElement(
        "option",
        {
          key: "group_user_" + row["user_id"],
          value: row["user_id"]
        },
        row["account_name"]
      );
    });
  },
  rightTopBarLinks: function() {
    if (Auth.isAuthenticated()) {
      return /* @__PURE__ */ React.createElement("ul", { className: "right" }, /* @__PURE__ */ React.createElement("li", { id: "load-quick-search", className: "has_form" }, /* @__PURE__ */ React.createElement(LoadQuickSearch, { location: this.props.location })), this.dashboardLinkOrDropdown(), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Link, { to: "/activity" }, "Activity")), this.emailSearchLink(), this.settingsLink(), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Link, { to: "/help" }, "Help")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(BeamerUpdates, null)), this.groupUsers(), this.logoutLink());
    }
  },
  documentPageExists: function() {
    return "documentPage" in window;
  },
  render: function() {
    if (this.documentPageExists()) {
      return /* @__PURE__ */ React.createElement("div", { id: "mainViewContainer" }, this.sandboxMessage(), this.trainingHeader(), this.mainView(
        this.props.mailbox,
        this.props.model,
        this.props.children
      ));
    } else {
      const headerFlagsForElm = this.headerFlagsForElm();
      const legacyNavbar = headerFlagsForElm.v3ReskinTopLevelEnabled ? null : this.navbar();
      return /* @__PURE__ */ React.createElement("div", { className: "react-wrapper" }, /* @__PURE__ */ React.createElement(
        StaffBar,
        {
          location: this.props.location,
          currentUser: Auth._currentUser,
          loggedIn: this.state.loggedIn,
          showV3ReskinTopLevelCheckbox: Auth.v3ReskinTopLevelSettingEnabled(),
          toggleV3ReskinTopLevel: this.toggleV3ReskinTopLevel,
          v3ReskinTopLevelEnabled: headerFlagsForElm.v3ReskinTopLevelEnabled
        }
      ), /* @__PURE__ */ React.createElement("div", { className: "contain-to-grid" }, legacyNavbar), /* @__PURE__ */ React.createElement(AlertArea, null), /* @__PURE__ */ React.createElement("div", { id: "container", className: this.containerClass() }, /* @__PURE__ */ React.createElement("div", { id: "flash-messages" }, /* @__PURE__ */ React.createElement(FlashMessages, null)), /* @__PURE__ */ React.createElement("div", null, this.customAlertMessage(), this.sandboxMessage(), this.trainingHeader()), /* @__PURE__ */ React.createElement("div", { id: "elm-container", className: this.innerClass() }, /* @__PURE__ */ React.createElement(
        ElmApp,
        {
          ref: "elmApp",
          location: this.props.location,
          headerFlags: headerFlagsForElm,
          switchUserCallback: this.switchUser
        }
      )), /* @__PURE__ */ React.createElement("div", { id: "mainViewContainer" }, this.mainView(
        this.props.mailbox,
        this.props.model,
        this.props.children
      ))));
    }
    ;
  },
  v3ReskinTopLevelEnabled: function() {
    return Auth.v3ReskinTopLevelSettingEnabled() && this.state.v3ReskinTopLevelChecked;
  },
  headerFlagsForElm() {
    let accounts = [];
    if (Auth.isAuthenticated()) {
      let user = Auth.getCurrentUser();
      if (user.group_user_info && user.group_user_info.length > 0) {
        accounts = user.group_user_info.map((group_user) => {
          return {
            id: group_user["user_id"],
            name: group_user["account_name"],
            isCurrent: group_user["user_id"] === user.id
          };
        });
      }
    }
    return {
      v3ReskinTopLevelEnabled: !!this.v3ReskinTopLevelEnabled() && !this.props.model.hideNavbar,
      dashboardLinkLocation: this.dashboardLinkUrl(),
      headerDropdownPages: this.headerDropdownPages(),
      headerRightPages: this.headerRightPages(),
      hasSettingsRole: !!this.hasSettingsRole(),
      useSubmissionWorkflow: !!Account.useSubmissionWorkflow(),
      isFactor: !!Account.hasRole("Factor"),
      accounts
    };
  },
  navbar: function() {
    if (!this.props.model.hideNavbar) {
      return /* @__PURE__ */ React.createElement("nav", { className: "top-bar main-nav", "data-topbar": true, role: "navigation" }, /* @__PURE__ */ React.createElement("ul", { className: "title-area show-for-large-up" }, /* @__PURE__ */ React.createElement("li", { className: "name" }, /* @__PURE__ */ React.createElement("h1", null, /* @__PURE__ */ React.createElement(
        Link,
        {
          to: this.dashboardLinkLocation(),
          query: this.dashboardParams()
        },
        /* @__PURE__ */ React.createElement(
          "img",
          {
            src: "/assets/TriumphLogoWhite.svg",
            className: "hubtran-logo"
          }
        )
      )))), /* @__PURE__ */ React.createElement("section", { className: "top-bar-section" }, /* @__PURE__ */ React.createElement(ModuleDropdown, { location: this.props.location }), this.rightTopBarLinks()));
    }
  },
  customAlertMessage: function() {
    if (Auth._currentUser && Auth._currentUser.account && Auth._currentUser.account.settings && Auth._currentUser.account.settings.custom_alert_message) {
      const message = Auth._currentUser.account.settings.custom_alert_message;
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box alert-box--caution centered sandbox-warning" }, message);
    }
  },
  sandboxMessage: function() {
    if (isSandbox() && !this.isTrainingAccount() && !onScraperPage(this.props.location)) {
      const loadEmailSandboxRecipients = Api.Account.loadEmailSandboxRecipients();
      let message = "This account is currently in sandbox mode. No invoices will be sent to external systems.";
      if (loadEmailSandboxRecipients) {
        message += " All emails will go to " + _.str.toSentenceSerial(loadEmailSandboxRecipients, ", ") + ".";
      }
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box warning centered sandbox-warning" }, message);
    }
  },
  trainingHeader: function() {
    if (this.isTrainingAccount() && Auth._currentUser && Auth._currentUser.terms_agreed_to_at) {
      if (this.state.showTrainingVideo) {
        return /* @__PURE__ */ React.createElement("div", null, this.trainingHeaderNav(), /* @__PURE__ */ React.createElement(
          TrainingEnvironmentVideo,
          {
            videoUrl: this.state.training.videoUrl,
            showVideoCallback: this.showTrainingVideo,
            accountId: this.account().id
          }
        ));
      } else if (this.state.showTrainingLessonToC) {
        return /* @__PURE__ */ React.createElement("div", null, this.trainingHeaderNav(), /* @__PURE__ */ React.createElement(
          TrainingEnvironmentToC,
          {
            accountId: this.account().id,
            lessons: this.state.training.lessons,
            trainingUserToken: this.state.training.userToken,
            showLessonToC: this.showTrainingLessonToC
          }
        ));
      } else {
        return /* @__PURE__ */ React.createElement("div", null, this.trainingHeaderNav());
      }
    }
  },
  trainingHeaderNav: function() {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      TrainingEnvironmentNavigation,
      {
        accountId: this.account().id,
        showVideoCallback: this.showTrainingVideo,
        showLessonToC: this.showTrainingLessonToC,
        lesson: this.state.training.currentLesson,
        trainingUserToken: this.state.training.userToken,
        loading: this.state.training.loading,
        allLessonsCompleted: this.state.training.lessons.every((a) => a.completed_at)
      }
    ));
  },
  mainView: function(mailbox, model, children) {
    return children;
  },
  dashboardParams: function() {
    if (this.props.location.pathname === "/dashboard" || this.props.location.pathname === "/dashboard/new") {
      return this.props.location.query;
    } else if (this.props.location.pathname === "/dashboard/replies") {
      return ListFilterHelper.queryWithFilters(Auth._currentUser.settings.preferred_filter || { "All": "true" });
    } else if (this.isIndexAuditSplitAccount() && localStorage.getItem("dashboardDestination")) {
      const dashboardDestination = localStorage.getItem("dashboardDestination");
      return { dashboardMode: dashboardDestination === "/dashboard/ready-to-audit" ? "audit" : "index" };
    }
  },
  account() {
    return Auth._currentUser && Auth._currentUser.account;
  },
  isPayablesAccount() {
    const account = this.account();
    return account && account.payables_account;
  },
  isTrainingAccount() {
    const account = this.account();
    return account && account.is_training;
  },
  isIndexAuditSplitAccount() {
    const account = this.account();
    return account && account.index_audit_split_enabled;
  },
  showTrainingVideo(showVideo) {
    this.setState({
      showTrainingVideo: showVideo
    });
  },
  showTrainingLessonToC(showToC) {
    this.setState({
      showTrainingLessonToC: showToC
    });
  },
  dashboardLinkLocation() {
    if (this.isIndexAuditSplitAccount()) {
      const localStorageValue = localStorage.getItem("dashboardDestination");
      if (localStorageValue === "/dashboard/new" || localStorageValue === "/dashboard/ready-to-audit") {
        return localStorageValue;
      }
    }
    return Account.matchAccountType({
      broker: () => this.isPayablesAccount() ? "/dashboard" : "/to_be_scraped_loads",
      factor: () => "/dashboard",
      forwarder: () => "/dashboard"
    });
  },
  dashboardLinkUrl() {
    return [
      this.dashboardLinkLocation(),
      new URLSearchParams(this.dashboardParams()).toString()
    ].join("?");
  },
  emailSearchLink() {
    if (Api.Account.currentSettings().email_search_account) {
      return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Link, { to: "/email_search" }, "Email Search"));
    }
  },
  headerRightPages: function() {
    if (!Auth.isAuthenticated()) {
      return [];
    }
    ;
    const isIndexer = !!Auth.getCurrentUser().indexer;
    const isAuditor = !!Auth.getCurrentUser().auditor;
    const isAdmin = !!Auth.getCurrentUser().admin;
    const indexDashboardUrl = this.isPayablesAccount() ? "/app/dashboard/new?dashboardMode=index" : "/app/dashboard/indexing?dashboardMode=index";
    const auditDashboardUrl = this.isPayablesAccount() ? "/app/dashboard/ready-to-audit?dashboardMode=audit" : "/app/dashboard/new?dashboardMode=audit";
    const indexQueuesLink = {
      title: "Index queues",
      url: indexDashboardUrl,
      isVisible: true,
      possibleLocationRegexes: [
        "^/app/dashboard$",
        "^/app/dashboard/new$",
        "^/app/dashboard.*dashboardMode=index",
        "^/app/index-document-batches"
      ]
    };
    const auditQueuesLink = {
      title: "Audit queues",
      url: auditDashboardUrl,
      isVisible: true,
      possibleLocationRegexes: [
        "^/app/dashboard.*dashboardMode=audit",
        "^/app/loads/"
      ]
    };
    let indexAuditLinks;
    if (this.isIndexAuditSplitAccount()) {
      if (isIndexer && isAuditor || isAdmin) {
        indexAuditLinks = [indexQueuesLink, auditQueuesLink];
      } else if (isIndexer) {
        indexQueuesLink.title = "Queues";
        indexQueuesLink.possibleLocationRegexes.push("^/app/dashboard");
        indexAuditLinks = [indexQueuesLink];
      } else if (isAuditor) {
        auditQueuesLink.title = "Queues";
        auditQueuesLink.possibleLocationRegexes.push("^/app/dashboard");
        indexAuditLinks = [auditQueuesLink];
      } else {
        indexAuditLinks = [];
      }
    } else {
      indexQueuesLink.title = "Queues";
      indexQueuesLink.possibleLocationRegexes.push("^/app/dashboard");
      indexQueuesLink.url = this.dashboardLinkUrl();
      indexAuditLinks = [indexQueuesLink];
    }
    const links = indexAuditLinks.concat([{
      title: "Email search",
      url: "/app/email_search",
      isVisible: Api.Account.currentSettings().email_search_account,
      possibleLocationRegexes: [
        "^/app/email_search",
        "^/app/email/"
      ]
    }, {
      title: "Activity",
      url: "/app/activity",
      isVisible: true,
      possibleLocationRegexes: [
        "^/app/activity"
      ]
    }, {
      title: "Held submissions",
      url: "/app/held_submissions",
      isVisible: !!Api.Account.currentSettings().ltl_held_submissions_page_enabled,
      possibleLocationRegexes: [
        "^/app/held_submissions"
      ]
    }]);
    return links.filter((link) => link.isVisible).map((link) => {
      return {
        title: link.title,
        url: link.url,
        possibleLocationRegexes: link.possibleLocationRegexes
      };
    });
  },
  dashboardLinkOrDropdown: function() {
    const isIndexer = !!Auth.getCurrentUser().indexer;
    const isAuditor = !!Auth.getCurrentUser().auditor;
    const isAdmin = !!Auth.getCurrentUser().admin;
    if (this.isIndexAuditSplitAccount()) {
      if (isIndexer && isAuditor || isAdmin) {
        return this.indexAuditDropdownMenu();
      } else if (isIndexer) {
        return this.indexDashboardLink("Dashboard");
      } else if (isAuditor) {
        return this.auditDashboardLink("Dashboard");
      } else {
        return this.dashboardLink();
      }
    } else {
      return this.dashboardLink();
    }
  },
  indexAuditDropdownMenu: function() {
    return /* @__PURE__ */ React.createElement("ul", { className: "left", id: "module-dropdown" }, /* @__PURE__ */ React.createElement("li", { className: "has-dropdown not-click" }, /* @__PURE__ */ React.createElement("a", null, "Dashboard"), /* @__PURE__ */ React.createElement("ul", { className: "dropdown" }, this.indexDashboardLink("Index"), this.auditDashboardLink("Audit"))));
  },
  dashboardLink() {
    return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
      Link,
      {
        to: this.dashboardLinkLocation(),
        query: this.dashboardParams()
      },
      "Dashboard"
    ));
  },
  indexDashboardLink(label) {
    const route = this.isPayablesAccount() ? "/dashboard/new" : "/dashboard/indexing";
    return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
      Link,
      {
        to: route,
        query: { "dashboardMode": "index" },
        onClick: () => this.isIndexAuditSplitAccount() && localStorage.setItem("dashboardDestination", route)
      },
      label
    ));
  },
  auditDashboardLink(label) {
    const route = this.isPayablesAccount() ? "/dashboard/ready-to-audit" : "/dashboard/new";
    return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
      Link,
      {
        to: route,
        query: { "dashboardMode": "audit" },
        onClick: () => this.isIndexAuditSplitAccount() && localStorage.setItem("dashboardDestination", route)
      },
      label
    ));
  },
  settingsLink() {
    if (this.hasSettingsRole()) {
      return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Link, { to: "/settings" }, "Settings"));
    }
  },
  hasSettingsRole() {
    return Auth.getCurrentUser() && !!Auth.getCurrentUser().settings_role;
  },
  switchUser(userId) {
    let current_user = Auth.getCurrentUser();
    if (current_user.id != userId) {
      Auth.switchUser(userId);
      return true;
    }
    return false;
  },
  switchUserFromSelect(event) {
    this.switchUser(parseInt(event.target.value));
  },
  containerClass() {
    if (this.v3ReskinEnabled()) {
      return "v3_reskin__container";
    } else {
      return "";
    }
  },
  innerClass() {
    if (this.v3ReskinEnabled()) {
      return "v2__theme";
    } else {
      return "v2__theme";
    }
  },
  v3ReskinEnabled() {
    return Auth._currentUser && Auth._currentUser.account && Auth._currentUser.account.settings && Auth._currentUser.account.settings.audit_v3_reskin_enabled_settings;
  },
  toggleV3ReskinTopLevel() {
    const enabled = !this.state.v3ReskinTopLevelChecked;
    this.setState({ v3ReskinTopLevelChecked: enabled });
    this.refs.elmApp.toggleV3ReskinTopLevel(enabled);
  },
  shouldRenderV3ReskinTopLevel() {
    return Auth.v3ReskinTopLevelSettingEnabled() && this.state.v3ReskinTopLevelChecked;
  },
  headerDropdownPages: function() {
    const account = this.account();
    return {
      payables: !!(account && (account.payables_account || account.factor_account)),
      receivables: !!(account && account.receivables_account && Auth._currentUser.receivables),
      insights: !!(account && (account.broker_account || account.settings.insights_dashboard_enabled) && Auth._currentUser.insights_dashboard_access),
      ltlDocRetrieval: !!(account && account.scraper_account),
      customerRep: !!(account && account.customer_representative_view_enabled && Auth._currentUser.customer_representative)
    };
  }
});
export default App;
